import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgxFloatUiPlacements } from 'ngx-float-ui';
import { PopperToolTipComponent } from '../../../../popper/components/popper-tool-tip/popper-tool-tip.component';
import { ButtonComponent, ButtonSizeEnumPipe, ButtonStyleEnumPipe, ButtonShapeEnumPipe, ButtonColorEnumPipe, ModalComponent, ModalSizeEnumPipe } from 'ui-library-shared';

@Component({
    selector: 'ui-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
  imports: [PopperToolTipComponent, ButtonComponent, ButtonSizeEnumPipe, ButtonStyleEnumPipe, ButtonShapeEnumPipe, ButtonColorEnumPipe,
            ModalComponent, ModalSizeEnumPipe]
})
export class FooterComponent implements OnInit {
  public isOpenPageModalShowing: boolean = false
  public linkToOpen: string;
  public popperPlacement: NgxFloatUiPlacements = NgxFloatUiPlacements.TOP;
  constructor() { }

  ngOnInit(): void {
  }

  public closeOpenPageModal() { this.isOpenPageModalShowing = false, this.linkToOpen = '' }

  public openExternalLink(link: string) {
    this.linkToOpen = link;
    this.isOpenPageModalShowing = true;
  }

  public handleOk() {
    window.open(this.linkToOpen, "_blank");
    this.isOpenPageModalShowing = false;
  }

  public handleCancel() {
    this.isOpenPageModalShowing = false;
    this.linkToOpen = '';
  }
}
